export default {
  handBaller: [
    {
      id: "Using a Hand Pallet Truck",
      title: "Using a Hand Pallet Truck"
    },
    {
      id: "Using Mobile Loading and Unloading Ramps",
      title: "Using Mobile Loading and Unloading Ramps"
    },
    {
      id: "Moving of Mobile Loading and Unloading Ramps",
      title: "Moving of Mobile Loading and Unloading Ramps"
    },
    {
      id: "Using Mobile Container Platform",
      title: "Using Mobile Container Platform"
    },
    {
      id: "Use of Knives and Scissors",
      title: "Use of Knives and Scissors"
    },
    {
      id: "Pallet Wrapping by Hand",
      title: "Pallet Wrapping by Hand"
    },
    {
      id: "Cutting Tension Strapping",
      title: "Cutting Tension Strapping"
    },
    {
      id: "Unloading of Containers or Loose Loads",
      title: "Unloading of Containers or Loose Loads"
    },
    {
      id: "Re-palatizing Fallen Stock",
      title: "Re-palatizing Fallen Stock"
    }
  ].sort((a, b) => a.title.localeCompare(b.title)),
  mhe: [
    {
      id: "Unloading Curtain Sided Vehicles",
      title: "Unloading Curtain Sided Vehicles"
    },
    {
      id: "Placing Pallets into Storage",
      title: "Placing Pallets into Storage"
    },
    {
      id: "Full Pallet Picking",
      title: "Full Pallet Picking"
    },
    {
      id: "Loading Curtain Sided Vehicles",
      title: "Loading Curtain Sided Vehicles"
    },
    {
      id: "Operation of Double-Deck Trailers",
      title: "Operation of Double-Deck Trailers"
    },
    {
      id: "Re-fuelling Diesel",
      title: "Re-fuelling Diesel"
    },
    {
      id: "Topping Up of MHE Batteries",
      title: "Topping Up of MHE Batteries"
    },
    {
      id: "Re-palatizing Fallen Stock",
      title: "Re-palatizing Fallen Stock"
    }
  ].sort((a, b) => a.title.localeCompare(b.title))
};
